class Search {
  constructor(rootElement) {
    this.rootElement = rootElement;

    if (this.rootElement) {
      this.findElements();
      this.initState();
      this.attachEvents();
    }
  }

  findElements() {
    this.resultElements = Array.from(this.rootElement.querySelectorAll('[data-entity="result-item"]'));
  }

  initState() {
    this.state = {
      inputValue: '',
      resultItemsIndex: [],
    };
  }

  attachEvents() {
    this.rootElement.addEventListener('input', this.inputChangeHandler.bind(this));
    this.rootElement.addEventListener('change', this.inputChangeHandler.bind(this));
  }

  inputChangeHandler(event) {
    if (!event.target.closest('[data-entity="input"]')) return;

    this.state.inputValue = event.target.value.toLowerCase();
    this.searchResultsIndexes();

    this.renderRootElement();
    this.renderResultElements();
  }

  searchResultsIndexes() {
    this.resultElements.forEach((resultItem, index) => {
      const resultItemValue = resultItem.textContent.toLowerCase();
      const isIndexAlreadyExist = this.state.resultItemsIndex.includes(index);
      const isValueHasSubstring = resultItemValue.includes(this.state.inputValue);

      if (!isValueHasSubstring && isIndexAlreadyExist) {
        this.state.resultItemsIndex = this.state.resultItemsIndex
          .filter((elementIndex) => elementIndex !== index);

        return;
      }

      if (!isValueHasSubstring || isIndexAlreadyExist) return;

      this.state.resultItemsIndex = [...this.state.resultItemsIndex, index];
    });
  }

  renderRootElement() {
    if (this.state.resultItemsIndex.length) {
      this.rootElement.classList.remove('search-persons_empty');
      this.rootElement.classList.add('search-persons_not-empty');
    }

    if (!this.state.resultItemsIndex.length) {
      this.rootElement.classList.remove('search-persons_not-empty');
      this.rootElement.classList.add('search-persons_empty');
    }
  }

  renderResultElements() {
    this.resultElements.forEach((resultItem, index) => {
      if (this.state.resultItemsIndex.includes(index)) {
        resultItem.classList.remove('search-persons__result-item_hidden');
        return;
      }

      resultItem.classList.add('search-persons__result-item_hidden');
    });
  }
}

export default Search;
